// Ethiopian (Amharic) time helpers for Lomi Live.
//
// Ethiopian clock runs 6 hours behind the Western clock and resets at 6am/6pm:
// 10:00 EAT = 4 ሰዓት (ጠዋት), 11:10 EAT = 5:10 (ጠዋት), 13:00 = 7 (ከሰዓት).
// We show the Amharic time ALONGSIDE the English one, e.g.
//   "Sat, Jun 20 · 10:00 AM EAT"  +  "ቅዳሜ ጠዋት 4 ሰዓት".

const AM_DAYS: Record<string, string> = {
  Sunday: 'እሁድ',
  Monday: 'ሰኞ',
  Tuesday: 'ማክሰኞ',
  Wednesday: 'ረቡዕ',
  Thursday: 'ሐሙስ',
  Friday: 'ዓርብ',
  Saturday: 'ቅዳሜ',
};

// "HH:MM" (24h) → English 12-hour label, e.g. "10 AM" / "10:40 AM". No "EAT".
export function engTime(eat: string): string {
  const [hStr, mStr] = (eat || '').split(':');
  const h = Number(hStr);
  const m = Number(mStr || 0);
  if (Number.isNaN(h)) return '';
  const ap = h < 12 ? 'AM' : 'PM';
  let h12 = h % 12;
  if (h12 === 0) h12 = 12;
  return m ? `${h12}:${String(m).padStart(2, '0')} ${ap}` : `${h12} ${ap}`;
}

// "HH:MM" EAT (24h) → Amharic clock label, e.g. "ጠዋት 4 ሰዓት" / "ጠዋት 4:40".
export function ethTime(eat: string): string {
  const [hStr, mStr] = (eat || '').split(':');
  const h = Number(hStr);
  const m = Number(mStr || 0);
  if (Number.isNaN(h)) return '';
  let eh = (h - 6) % 12;
  if (eh <= 0) eh += 12;
  const period = h < 12 ? 'ጠዋት' : h < 18 ? 'ከሰዓት' : 'ማታ'; // morning / afternoon / evening
  return m ? `${period} ${eh}:${String(m).padStart(2, '0')}` : `${period} ${eh} ሰዓት`;
}

// Amharic weekday (in EAT) for an ISO date, e.g. "ቅዳሜ".
export function amharicDay(iso: string | null): string {
  if (!iso) return '';
  try {
    const day = new Date(iso).toLocaleDateString('en-US', {
      weekday: 'long',
      timeZone: 'Africa/Addis_Ababa',
    });
    return AM_DAYS[day] || '';
  } catch {
    return '';
  }
}

// Full Amharic "when": "ቅዳሜ ጠዋት 4 ሰዓት" (day + optional clock time).
export function amharicWhen(iso: string | null, eat?: string): string {
  const day = amharicDay(iso);
  const t = eat ? ethTime(eat) : '';
  return [day, t].filter(Boolean).join(' ');
}
